"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupMenuId = {
    dashboard: 'dashboard',
    inventory: 'inventory',
    campaign: 'campaign',
    campaignBasic: 'campaignBasic',
    report: 'report',
    permission: 'permission',
    system: 'system',
    user: 'user',
    income: 'income',
    priority: 'priority',
    hotspot: 'hotspot',
    logs: 'logs'
};
//# sourceMappingURL=groupMenu.js.map